import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const commonapi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'commonapi',
    endpoints: (builder) => ({

        getAllSkillCategory: builder.query({
            query: (name) => ({
                url: `/student/skill-category/dropdown?name=${name}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    }),
});

export const {
    useLazyGetAllSkillCategoryQuery
} = commonapi;

export default commonapi;
